export default {"src":"/_next/static/media/undraw_education_f8ru.e8b1dbe1.svg","height":539,"width":744};